import React from 'react'

export const IconPaperclip = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M14.2929 7.36629L8.16621 13.493C7.41565 14.2435 6.39767 14.6652 5.33621 14.6652C4.27475 14.6652 3.25677 14.2435 2.50621 13.493C1.75565 12.7424 1.33398 11.7244 1.33398 10.663C1.33398 9.6015 1.75565 8.58352 2.50621 7.83296L8.63288 1.70629C9.13325 1.20591 9.81191 0.924805 10.5195 0.924805C11.2272 0.924805 11.9058 1.20591 12.4062 1.70629C12.9066 2.20666 13.1877 2.88532 13.1877 3.59295C13.1877 4.30059 12.9066 4.97925 12.4062 5.47962L6.27288 11.6063C6.02269 11.8565 5.68336 11.997 5.32954 11.997C4.97572 11.997 4.6364 11.8565 4.38621 11.6063C4.13602 11.3561 3.99547 11.0168 3.99547 10.663C3.99547 10.3091 4.13602 9.96981 4.38621 9.71962L10.0462 4.06629"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
